import { Button, Col, Form, Row } from 'antd';
import { OptionEntity } from 'domain/entities/OptionEntity';
import { AppProps } from 'presentation/App';
import { BUYER_CLASSIFICATION } from 'presentation/components/HeaderRightComponent';
import { openErrorNoti, openSuccessNoti } from 'presentation/components/Notification';
import { PageTitle } from 'presentation/components/PageTitle';
import { completeFetching, startFetching } from 'presentation/redux/features/app/appSlice';
import { useAppDispatch, useAppSelector } from 'presentation/redux/hooks';
import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { DATE_FORMAT } from 'utilities/constants/DATE';
import getMessage from 'utilities/constants/MESSAGE';
import { commonHelpers } from 'utilities/helpers';
import FormRegisInfomantion from './component/FormRegistInfomantion';

export const CU06201Page = (props: AppProps) => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const { settlementId } = useParams();
    const [form] = Form.useForm();
    const [masterData, setMasterData] = React.useState<any>();
    const userSlice = useAppSelector((state) => state.user);

    const [btnDisable, setBtnDisable] = React.useState<boolean>(true);
    const [editabled, setEditabled] = React.useState<boolean>(true);

    const { masterUseCase } = props;

    useEffect(() => {
        if (settlementId) {
            getInitInfo();
        }
    }, [settlementId]);
    const submitForm = async (value: any) => {
        if (value) {
            const payload = {
                ...value,
                settlementId: Number(settlementId),
                scheduleAdjustmentDiv: userSlice.implementerClassification ?? BUYER_CLASSIFICATION,
            };
            try {
                dispatch(startFetching());
                const response = await masterUseCase.updateSettingProperty(payload);
                if (response.status == 200) {
                    openSuccessNoti({ description: getMessage('S0323') });
                    navigate(-1);
                }
            } catch (error) {
                openErrorNoti();
            } finally {
                dispatch(completeFetching());
            }
        }
    };
    const getInitInfo = async () => {
        if (settlementId) {
            try {
                dispatch(startFetching());
                const responses = await Promise.all([
                    masterUseCase.getSettingProperty({
                        settlementId: Number(settlementId),
                        scheduleAdjustmentDiv:
                            userSlice.implementerClassification ?? BUYER_CLASSIFICATION,
                    }),
                    masterUseCase.getListOptionTime(),
                ]);
                const preferred01Date = responses[0]?.result?.preferred01Date;
                const preferred02Date = responses[0]?.result?.preferred02Date;
                const preferred03Date = responses[0]?.result?.preferred03Date;
                if (preferred01Date && preferred02Date && preferred03Date) {
                    setEditabled(false);
                }
                const dataResult = {
                    ...responses[0]?.result,
                    proposed01Date: responses[0]?.result?.proposed01Date
                        ? commonHelpers.formatDate(
                              responses[0]?.result?.proposed01Date,
                              DATE_FORMAT.FORMAT1,
                          )
                        : null,
                    proposed02Date: responses[0]?.result?.proposed02Date
                        ? commonHelpers.formatDate(
                              responses[0]?.result?.proposed02Date,
                              DATE_FORMAT.FORMAT1,
                          )
                        : null,
                    proposed03Date: responses[0]?.result?.proposed03Date
                        ? commonHelpers.formatDate(
                              responses[0]?.result?.proposed03Date,
                              DATE_FORMAT.FORMAT1,
                          )
                        : null,
                    preferred01Date: responses[0]?.result?.preferred01Date
                        ? commonHelpers.formatDate(
                              responses[0]?.result?.preferred01Date,
                              DATE_FORMAT.FORMAT1,
                          )
                        : null,
                    preferred02Date: responses[0]?.result?.preferred02Date
                        ? commonHelpers.formatDate(
                              responses[0]?.result?.preferred02Date,
                              DATE_FORMAT.FORMAT1,
                          )
                        : null,
                    preferred03Date: responses[0]?.result?.preferred03Date
                        ? commonHelpers.formatDate(
                              responses[0]?.result?.preferred03Date,
                              DATE_FORMAT.FORMAT1,
                          )
                        : null,
                };
                form.setFieldsValue(dataResult);
                const timeSettings: string[] = responses[1]?.result;
                const timeOptions: OptionEntity[] = [];
                for (let i = 0; i < timeSettings.length - 1; i++) {
                    timeOptions.push({
                        label: `${timeSettings[i]}-${timeSettings[i + 1]}`,
                        value: `${timeSettings[i]}-${timeSettings[i + 1]}`,
                    });
                }
                const dayOptions: OptionEntity[] = [];
                pushDate(dayOptions, dataResult?.proposed01Date);
                pushDate(dayOptions, dataResult?.proposed02Date);
                pushDate(dayOptions, dataResult?.proposed03Date);
                setMasterData({
                    timeOptions,
                    dayOptions,
                });
            } catch (error) {
                openErrorNoti();
            } finally {
                dispatch(completeFetching());
            }
        }
    };

    const pushDate = (dayOptions: OptionEntity[], date?: string | null) => {
        if (date) {
            const option = dayOptions.find((item) => item.value === date);
            if (!option) {
                dayOptions.push({
                    label: commonHelpers.formatDateWithWeekDay(date),
                    value: date,
                });
            }
        }
    };

    const onChangeForm = () => {
        form.validateFields({
            validateOnly: true,
        })
            .then(() => {
                setBtnDisable(false);
            })
            .catch((err) => {
                setBtnDisable(err.errorFields.length > 0);
            });
    };

    return (
        <div
            style={{
                width: '100%',
                height: '100%',
                display: 'flex',
                flexFlow: 'column',
            }}
            className="cu-043-01"
        >
            <PageTitle title="司法書士最終確認日時の登録" showTypeSelect={false} />
            <section
                style={{
                    padding: '10px 0px',
                    height: '100%',
                    width: '100%',
                    overflow: 'auto',
                    flexGrow: 1,
                    display: 'flex',
                    justifyContent: 'center',
                    overflowX: 'hidden',
                }}
            >
                <div id="top-form" className="flex justify-center w-full">
                    <div className="section-wrapper">
                        <Form
                            form={form}
                            onValuesChange={onChangeForm}
                            onFinish={submitForm}
                            className="w-full"
                        >
                            <FormRegisInfomantion masterData={masterData} />
                            <Row gutter={[24, 0]} className="justify-center mb-[30px]">
                                <Col span={12}>
                                    <Button
                                        type="primary"
                                        htmlType="submit"
                                        style={{ width: '100%', height: 56, marginTop: 16 }}
                                        disabled={!editabled || btnDisable}
                                    >
                                        登録する
                                    </Button>
                                </Col>
                            </Row>
                        </Form>
                    </div>
                </div>
            </section>
        </div>
    );
};
